import { AES, Utf8, CBC, Hex, Base64, Word32Array } from '@pathfndr/crypto';
import { APP_CONFIG } from '../../core/constants/app.constants';

export class EncryptionHandler {    
    static encrypted: any;

    public static encryptData(key, ivText, type, param) {
        const parsedkey = Utf8.parse(key);
        const iv = Hex.parse(ivText);
        const wordArray = new Word32Array(iv);
        switch (type) {
            case 'AES':
                this.encrypted = AES.encrypt(param, parsedkey, { iv: iv, mode: CBC });
        }

        const IVBase64 = Base64.stringify(wordArray);
        const fullEncrypted: string = this.encrypted.toString() + '|' + IVBase64.toString();

        return fullEncrypted.toString();
    }

    public static getCryptData(agency_id, paramName, paramValue) {
        // TODO: need to get from list of params from API based on agency_id
        const list = ['password'];
        let cryptedData: any;
        if (list.includes(paramName)) {
            if (agency_id) {
                // TODO : get the secretKey, IV and algo type from API, based on agency_id
            } else {
                const key = APP_CONFIG.CRYPTO_KEY;
                const iv = APP_CONFIG.CRYPTO_IV;
                const type = 'AES';
                cryptedData = this.encryptData(key, iv, type, paramValue);
            }
            return cryptedData;
        } else {
            return paramValue;
        }
    }
}
